import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { EntitiesEnum, Match, Competition } from '@match-fix/shared';

import { Configuration } from '../configuration';
import { CrudService } from '../crud.service';
import { BASE_PATH } from '../variables';

@Injectable({
  providedIn: 'root'
})
export class CompetitionsService extends CrudService<Match> {
  constructor(public httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration) {
    super(EntitiesEnum.Competitions, httpClient, basePath, configuration);
  }

  async getCurrentUserCompetitions(): Promise<Competition[]> {
    const headers = this.defaultHeaders;
    const url = this.getEntityServiceEndpoint();

    return this.httpClient.get<Competition[]>(
      `${url}/me`, {
      withCredentials: true,
      headers,
      observe: 'body',
      reportProgress: false
    }).toPromise();
  }

}
